import './local-env';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import '@kargotech/tms-common/Assets/Fonts/Roboto/roboto.css';
import '@kargotech/tms-ui/_settings/app.css';
import './services/sentry';
import './services/i18n';

if (process.env.REACT_APP_ENVIRONMENT === 'DEV') {
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  const worker = require('./mocks/browser').default;
  worker.start({ serviceWorker: { url: '/mockServiceWorker.js' }, onUnhandledRequest: 'bypass' });
}

ReactDOM.render(
  /**
   * Currently there is a problem with antd Button that it produces warning on console's browser.
   * Track github issue here: https://github.com/ant-design/ant-design/issues/22493.
   * We will remove React.StrictMode temporaryly until it got resolved.
   */
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
  <App />,
  document.getElementById('root'),
);
